import { styled } from "@mui/material/styles";
import { Grid, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled(Grid)({
  width: "100%",
  margin: "10px 0",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  gap: "10px",
});

export const DeletButton = styled(IconButton)({
  fontSize: "1rem",
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));
